// extracted by mini-css-extract-plugin
module.exports = {"modal":"ContentModal_modal__f8RpI","image":"ContentModal_image__SRUyL"};